import { render, staticRenderFns } from "./ProjectContentGeneral.vue?vue&type=template&id=6b4012a2"
import script from "./ProjectContentGeneral.vue?vue&type=script&lang=ts"
export * from "./ProjectContentGeneral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports